import {
	VehicleMakeSearchDto,
	VehicleModelSearchDto,
} from '@splitsecondconnect/ultramarine-shared';
import { plainToInstance } from 'class-transformer';

import { SelectItem } from '../../../../../../../shared/models/select-item.type';

export function mapDtoToModelVehicleMakes(
	makes: VehicleMakeSearchDto[],
): SelectItem<VehicleMakeSearchDto>[] {
	return makes.map((make) => {
		const instance = plainToInstance(VehicleMakeSearchDto, make);
		return {
			value: make,
			pillColor: make.color,
			displayValue: instance.displayValue(),
			shortDisplayValue: instance.shortDisplayValue(),
			extraDisplayValue: instance.extraDisplayValue(),
			pillDisplayValue: instance.pillDisplayValue(),
		};
	});
}

export function mapDtoToModelVehicleModels(
	models: VehicleModelSearchDto[],
): SelectItem<VehicleModelSearchDto>[] {
	return models.map((model) => {
		const instance = plainToInstance(VehicleModelSearchDto, model);
		return {
			value: model,
			pillColor: model.color,
			displayValue: instance.displayValue(),
			shortDisplayValue: instance.shortDisplayValue(),
			extraDisplayValue: instance.extraDisplayValue(),
			pillDisplayValue: instance.pillDisplayValue(),
		};
	});
}
